import { Injectable } from '@angular/core';
import { BaseHttpService, PageResponse } from '../../auth/base-capacitor-http';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';


export class DeliveryItem{
  id: number;
  name: string;
  url: string;
  quantity: number;
}
export class DeliveryItemSearchParams{
  page: number;
  size: number;

}

@Injectable({
  providedIn: 'root',
})
export class DeliveryItemService extends BaseHttpService {

  private baseURL: string = 'social/post';
  private endPointURL: string;
  constructor(protected client: HttpClient, protected snackbar: MatSnackBar) {
    super(client, snackbar);
  }

  async create(data: DeliveryItem) {
    this.endPointURL = this.baseURL;
    return await this.post<DeliveryItem>(this.endPointURL, data);
  }

  async update(data: DeliveryItem) {
    this.endPointURL = this.baseURL;
    return await this.put<DeliveryItem>(this.endPointURL, data);
  }

  async deleteById(id: string) {
    this.endPointURL = this.baseURL + id;
    return await this.delete<boolean>(this.endPointURL);
  }

  async findAll(searchParams: DeliveryItemSearchParams) {
    this.endPointURL = this.baseURL;
    return await this.get<PageResponse<DeliveryItem>>(this.endPointURL, searchParams);
  }

  async findById(id: string) {
    this.endPointURL = this.baseURL + '/' + id;
    return await this.get<DeliveryItem>(this.endPointURL);
  }

  async findByRef(ref: string) {
    this.endPointURL = this.baseURL + '/ref/' + ref;
    return await this.get<DeliveryItem>(this.endPointURL);
  }

}
